<template>
  <b-card>
    <h4 class="mb-2">
      <font-awesome-icon class="mr-50 ml-1" icon="fa-solid fa-calculator" /> 項目管理
    </h4>
    <b-tabs class="project-tabs" pills>
      <!-- Tab: stage -->
      <b-tab active  v-if="ability.can('read', 'settings_project_stage')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-people-carry-box"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">項目階段</span>
        </template>

        <stage-list class="" />
      </b-tab>
      <!-- Tab: project status -->
      <b-tab v-if="ability.can('read', 'settings_project_status')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-people-carry-box"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">項目狀態</span>
        </template>

        <project-status-list class="" />
      </b-tab>
      <!-- Tab: booking status-->
      <b-tab v-if="ability.can('read', 'settings_project_booking_stage')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-truck-field"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">項目預訂狀態</span>
        </template>

        <project-booking-status-list class="" />
      </b-tab>
      <!-- Tab: document type-->
      <b-tab v-if="ability.can('read', 'settings_project_document_type')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-truck-field"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">項目文件類型</span>
        </template>

        <project-document-type-list class="" />
      </b-tab>
      <!-- Tab: comment type-->
      <b-tab v-if="ability.can('read', 'settings_project_comment_type.read')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-truck-field"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">項目評輪類型</span>
        </template>

        <project-comment-type-list class="" />
      </b-tab>
      <!-- Tab: activity type-->
      <b-tab v-if="ability.can('read', 'settings_project_activitice_type')">
        <template #title>
          <font-awesome-icon
            icon="fa-solid fa-truck-field"
            class="mr-0 mr-sm-50 d-inline d-sm-none"
          />
          <span class="d-none d-sm-inline">項目活動類型</span>
        </template>

        <activity-type-list class="" />
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import stageList from "./stage/stages-list/stagesList.vue";
import projectStatusList from "./project-status/project-statuses-list/projectStatusesList.vue";
import projectBookingStatusList from "./project-booking-status/project-booking-statuses-list/projectBookingStatusesList.vue";
import projectDocumentTypeList from "./project-document-type/project-document-types-list/projectDocumentTypesList.vue";
import projectCommentTypeList from "./project-comment-type/project-comment-types-list/projectCommentTypesList.vue";
import activityTypeList from "./activity-type/activity-types-list/activityTypesList.vue";
import ability from "@/libs/acl/ability";

export default {
  components: {
    stageList,
    projectStatusList,
    projectBookingStatusList,
    projectDocumentTypeList,
    projectCommentTypeList,
    activityTypeList,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  data() {
    return {
      ability,
    };
  },
  setup() {},
};
</script>
<style lang="scss" >
.project-tabs.tabs:not(.type-1) .nav-pills .nav-item {
    margin-left: 1rem;
}
</style>